import { useState } from "react";
import { Button, Grid, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import LegalbirdIoModal from "../Modal/LegalbirdIoModal";
import { ReleaseUpdatePublication } from "../../types/ReleaseUpdate";
import {
  fetchReleaseUpdateMediaObjects,
  getReleaseUpdateMediaObjectIds,
} from "../../services/releaseUpdateService";
import ReleaseUpdateContent from "./ReleaseUpdateContent";
import releaseUpdateStyles from "./releaseUpdatesStyles";

type ReleaseUpdateDialogProps = {
  publication: ReleaseUpdatePublication;
  isPreview: boolean;
  onClose: () => void;
  onOpenArchive: () => void;
};

export default function ReleaseUpdateDialog({
  publication,
  isPreview,
  onClose,
  onOpenArchive,
}: ReleaseUpdateDialogProps) {
  const [messageIndex, setMessageIndex] = useState(0);
  const mediaObjectIds = getReleaseUpdateMediaObjectIds([publication]);
  const { data: mediaObjects = [] } = useQuery({
    queryKey: ["releaseUpdateMediaObjects", mediaObjectIds],
    queryFn: () => fetchReleaseUpdateMediaObjects(mediaObjectIds),
  });
  const message = publication.messages[messageIndex];
  const isLastMessage = messageIndex === publication.messages.length - 1;
  let primaryButtonLabel = "Weiter";
  if (isLastMessage) {
    primaryButtonLabel = isPreview ? "Vorschau beenden" : "Schließen";
  }

  if (!message) {
    return null;
  }

  const handlePrimaryAction = () => {
    if (isLastMessage) {
      onClose();
      return;
    }
    setMessageIndex(messageIndex + 1);
  };

  return (
    <LegalbirdIoModal
      open
      handleClose={isPreview ? onClose : () => null}
      title={isPreview ? "Release-Update Vorschau" : "Release-Update"}
      hasActions={false}
      hideCloseButton={!isPreview}
      disableBackdropClick
      disableEscapeKeyDown={!isPreview}
      fullWidth
      maxWidth="md"
    >
      <ReleaseUpdateContent
        message={message}
        publishedAt={publication.publishedAt}
        mediaObjects={mediaObjects}
      />
      <Grid container spacing={2} sx={releaseUpdateStyles.dialogActions}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Typography sx={{ marginBottom: "0.25rem" }}>
            Meldung {messageIndex + 1} von {publication.messages.length}
          </Typography>
          <Button variant="text" sx={{ padding: 0, width: "auto" }} onClick={onOpenArchive}>
            Alle Release-Updates
          </Button>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Grid container spacing={1} sx={{ justifyContent: "flex-end" }}>
            <Grid>
              <Button
                variant="text"
                disabled={messageIndex === 0}
                onClick={() => setMessageIndex(messageIndex - 1)}
              >
                Zurück
              </Button>
            </Grid>
            <Grid>
              <Button variant="contained" onClick={handlePrimaryAction}>
                {primaryButtonLabel}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </LegalbirdIoModal>
  );
}
